var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "content-class": "overflow-visible",
      "nudge-right": "64",
      "max-width": "256",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_vm._t("default", null, null, {
          on
        })];
      }
    }], null, true)
  }, [_c('div', {
    staticClass: "white",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap btn-group overflow-hidden"
  }, _vm._l(_vm.BASIC_FRAMES, function (frame) {
    return _c('v-btn', {
      key: frame,
      staticClass: "pa-0 overflow-hidden white",
      staticStyle: {
        "width": "64px",
        "height": "64px",
        "border-radius": "unset"
      },
      attrs: {
        "input-value": _vm.options.frame == frame
      },
      on: {
        "click": function ($event) {
          return _vm.$set(_vm.options, 'frame', _vm.options.frame == frame ? null : frame);
        }
      }
    }, [_c('blob-frame', {
      staticStyle: {
        "position": "relative !important",
        "transform": "scale(.5)",
        "transform-origin": "bottom right",
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "frame": frame
      }
    }, [_vm.showBackground ? _c('div', {
      staticClass: "ec-blue",
      staticStyle: {
        "width": "100%",
        "height": "100%"
      }
    }) : _vm._e()])], 1);
  }), 1), _c('v-divider'), _c('div', {
    staticClass: "d-flex justify-center pa-3"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-group-right",
    on: {
      "click": function ($event) {
        _vm.setFrameOption('tail', _vm.BUBBLE_FRAME_TAILS[(_vm.frameOptionsTailI + 1) % 4]);
      }
    }
  }, [_c('v-icon', {
    style: {
      transform: `rotate(${90 * _vm.frameOptionsTailI}deg)`
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiArrowBottomLeftThick)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Tail position")])], 1), _c('color-picker-btn', {
    attrs: {
      "colors": [].concat(_vm.COLORS, [null]),
      "value": _vm.frameOptions.stroke
    },
    on: {
      "input": function (v) {
        return _vm.setFrameOption('stroke', v);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-group-left btn-group-right"
        }, on), [_c('v-icon', {
          style: {
            filter: _vm.frameOptions.stroke ? 'drop-shadow(0 0 1px #0003)' : null
          },
          attrs: {
            "color": _vm.frameOptions.stroke
          },
          domProps: {
            "innerHTML": _vm._s(_vm.frameOptions.stroke ? _vm.mdiCircleOutline : _vm.mdiCircleOffOutline)
          }
        }), _c('span', {
          staticClass: "btn-tooltip top"
        }, [_vm._v("Outline color")])], 1)];
      }
    }])
  }), _c('color-picker-btn', {
    attrs: {
      "colors": _vm.COLORS,
      "value": _vm.frameOptions.fill
    },
    on: {
      "input": function (v) {
        return _vm.setFrameOption('fill', v);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-group-left btn-group-right"
        }, on), [_c('v-icon', {
          staticStyle: {
            "filter": "drop-shadow(0 0 1px #0003)"
          },
          attrs: {
            "color": _vm.frameOptions.fill
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiCircle)
          }
        }), _c('span', {
          staticClass: "btn-tooltip top"
        }, [_vm._v("Fill color")])], 1)];
      }
    }])
  }), _c('v-menu', {
    attrs: {
      "offset-x": "",
      "nudge-right": "4",
      "min-width": "224",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-group-left"
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiBoxShadow)
          }
        }), _c('span', {
          staticClass: "btn-tooltip top"
        }, [_vm._v("Shadow")])], 1)];
      }
    }])
  }, [_c('div', {
    staticClass: "white d-flex align-center relative",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-slider', {
    staticClass: "ma-3",
    attrs: {
      "hide-details": "",
      "min": "0",
      "max": "100",
      "step": "5",
      "value": _vm.frameOptions.shadow * 10
    },
    on: {
      "input": function (v) {
        return _vm.setFrameOption('shadow', parseFloat(v / 10));
      }
    }
  })], 1)])], 1)]), _c('div', {
    staticClass: "d-flex flex-wrap btn-group"
  }, _vm._l(_vm.BUBBLE_FRAMES, function (_ref5) {
    var frame = _ref5.key;
    return _c('v-btn', {
      key: frame,
      staticClass: "pa-3 white",
      staticStyle: {
        "width": "128px",
        "height": "128px",
        "border-radius": "unset"
      },
      attrs: {
        "elevation": "0",
        "input-value": _vm.options.frame == frame
      },
      on: {
        "click": function () {
          if (_vm.options.frame == frame) {
            _vm.$set(_vm.options, 'frame', null);
          } else {
            if (!_vm.options.frame_options) _vm.$set(_vm.options, 'frame_options', Object.assign({}, _vm.frameOptions));
            _vm.$set(_vm.options, 'frame', frame);
          }
        }
      }
    }, [_c('blob-frame', {
      staticStyle: {
        "position": "relative !important",
        "width": "104px",
        "height": "104px"
      },
      attrs: {
        "frame": frame,
        "options": Object.assign({}, _vm.frameOptions, {
          shadow: !_vm.frameOptions.shadow && (!_vm.frameOptions.outline || _vm.frameOptions.outline == '#FEFEFE') && _vm.frameOptions.fill == '#FEFEFE' ? .5 : _vm.frameOptions.shadow
        })
      }
    })], 1);
  }), 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }